import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Redirect, Route} from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import Data from "./Data";

class ModalEditMaster extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields : {
                name : this.props.products['name'],
                userid : this.props.products['userid'],
                phone : this.props.products['phone'],
                bio : this.props.products['bio'],
                file : this.props.products['picture']
            },
            errors : {

            }
        }

    }

    componentDidMount() {

    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        fields[target.name] = target.value;
        this.setState({fields});
    }

    handleSubmit(event){

        event.preventDefault();

        this.handleValidation((valid)=>{
            if (valid){
                $('#'+this.props.id).modal('hide');
                this.handleRequest();
            } else {
                const {errors} = this.state;

                if (errors['no'] !== null ){
                    this.props.toast(errors['no'],3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    })
                }
                if (errors['name'] !== null ){
                    this.props.toast(errors['name'],3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    })
                }
                if (errors['bio'] !== null ){
                    this.props.toast(errors['bio'],3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    })
                }
            }
        })

    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = this.state.errors;
        let formIsValid = true;
        console.log("handleValidation");

        if (fields.name === this.props.products['name'] &&
            fields.userid === this.props.products['userid'] &&
            fields.phone === this.props.products['phone'] &&
            fields.bio === this.props.products['bio'] &&
            fields.file === this.props.products['picture']){
            formIsValid = false;
            errors['no'] = 'لطفا یکی از فیلدها را تغییر دهید!';
        }else {
            errors['no'] = null;
        }
        if (fields.name === ""){
            formIsValid = false;
            errors['name'] = 'لطفا نام استاد را وارد کنید!';
        }else {
            errors['name'] = null;
        }
        if (fields.bio === ""){
            formIsValid = false;
            errors['bio'] = 'لطفا بیوگرافی استاد را وارد کنید!';
        }else {
            errors['bio'] = null;
        }

        this.setState({errors}, ()=>{
            return callback(formIsValid);
        });
    }

    selectFile(text , id, btnid, imgid){

        $('#'+btnid).addClass('btn-outline-warning');
        $('#'+btnid).removeClass('btn-outline-danger');
        $('#'+btnid+' p').text("در حال بارگذاری ...");
        let filesize = ((text.target.files[0].size/1024)/1024).toFixed(4);

        if (filesize >= 5){
            this.props.toast("فایل بیشتر از 5 مگابایت حجم دارد",3000,"bg-warning",()=> {
                $('#liveToast').toast('show');
            });

            $('#'+btnid).addClass('btn-outline-primary');
            $('#'+btnid).removeClass('btn-outline-warning');
            $('#'+btnid+' p').text("تغییر عکس");
        }else {
            let filename = this.generate_random_string(6,'qwertyuiopasdfghjklzxcvbnm0123456789')+'_'+text.currentTarget.files[0].name;
            const url = Data.mainserver+'uploadFile.php';
            const formData = new FormData();
            formData.append('file',text.target.files[0],filename);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            axios.post(url, formData,config)
                .then(response => {
                    console.log(response.data);

                    if (response.data.hasOwnProperty('filename')){
                        const {fields} = this.state;
                        fields['file'] = response.data.filename;
                        this.setState({fields});
                        $('#'+imgid)[0].src = Data.mainserver+"images/"+response.data.filename;
                        $('#'+btnid).addClass('btn-outline-success');
                        $('#'+btnid).removeClass('btn-outline-warning');
                        $('#'+btnid+' span').removeClass('invisible');
                        $('#'+btnid+' p').text("عکس پیوست شد");
                    }
                })
                .catch(error => {
                    $('#'+btnid).addClass('btn-outline-danger');
                    $('#'+btnid).removeClass('btn-outline-warning')
                    $('#'+btnid+' p').text("عکس پیوست نشد !!!");
                    console.log(error);
                });
        }

    }
    deleteFile(e , imgid){

        $('#'+imgid)[0].src = Data.mainserver+"icons/user.png";

        const {fields} = this.state;
        fields['file'] = "";
        this.setState({fields});

    }

    generate_random_string(length,text){
        var result           = '';
        var charactersLength = text.length;
        for ( var i = 0; i < length; i++ ) {
            result += text.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    handleRequest(){
        $('#waitspinner').modal('show');

        const {name,userid,phone,bio,file} = this.state.fields;

        let data = new FormData();
        data.append('id',this.props.products['id']);
        data.append('name',name);
        data.append('userid',userid);
        data.append('phone',phone);
        data.append('bio',bio);
        data.append('file',file);

        console.log(file)
        axios.post(Data.server+'editMaster.php',data)
            .then(response=>{

                $('#waitspinner').modal('hide');
                $('div.modal-backdrop.fade.show').remove();


                if (response.data === "ok") {

                    this.props.toast("ویرایش با موفقیت انجام شد",3000,"bg-success",()=> {
                        $('#liveToast').toast('show');
                    });

                    this.props.products['name'] = name;
                    this.props.products['userid'] = userid;
                    this.props.products['phone'] = phone;
                    this.props.products['bio'] = bio;
                    this.props.products['picture'] = file;
                    this.setState({
                        name: this.props.products['name'],
                        userid: this.props.products['userid'],
                        phone: this.props.products['phone'],
                        bio: this.props.products['bio'],
                        file: this.props.products['picture']
                    })
                    if (file !== ""){
                        $('#'+this.props.masterid+' > td img#masterimg'+this.props.index)[0].src = Data.server+"images/"+file;
                    }
                    $('#'+this.props.masterid+' > td')[0].innerHTML = `<img id=${"masterimg"+this.props.index} class="circle-icon" style="z-index:'999'" width="64px" height="64px" src=${file===''?Data.mainserver+"icons/user.png":Data.mainserver + "images/" + file}>`;
                    $('#'+this.props.masterid+' > td')[1].innerText = name;
                    $('#'+this.props.masterid+' > td')[2].innerText = userid;
                    $('#'+this.props.masterid+' > td')[3].innerText = phone;
                    $('#'+this.props.masterid+' > td')[4].innerText = bio;

                }
                if (response.data === "duplicate userid") {

                    this.props.toast("نام کاربری تکراری است",3000,"bg-warning",()=> {
                        $('#liveToast').toast('show');
                    });

                }
                if (response.data.includes("error update")){
                    this.props.toast("خطای داخلی رخ داد",3000,"bg-danger",()=> {
                        $('#liveToast').toast('show');
                    });
                }

            })
            .catch(error=>{
                $('#progressTop').addClass('invisible');
                $('#r_fab').addClass('animate__animated animate__zoomIn');
                console.log(error);
            });
    }

    render() {
        const {id,masterid,products,index} = this.props;

        const {name , bio , userid , phone} = this.state.fields;
        const {errors} = this.state;

        let uploadid = "upload-file"+index;
        let btnid = "btn_file"+index;
        let imgid = "masterpicture"+index;

        return (
            <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={id+"Label"}
                                         aria-hidden="true">
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title" id={id+"Label"}>{"ویرایش "+products['name']}</h6>
                            <button type="button" className="close text-left ml-0" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <img id={imgid} className="circle-icon" style={{zIndex:'999'}} width="128px" height="128px"
                                 src={products['picture']===''?Data.mainserver+"icons/user.png":Data.mainserver + "images/" + products['picture']}/>

                            <input
                                className="novisible"
                                id={uploadid}
                                multiple
                                type="file"
                                accept="image/jpeg, image/png"
                                onChange={(e) => this.selectFile(e,products['id'],btnid,imgid)}
                            />
                            <button onClick={(e) => $('#'+uploadid).trigger('click')} type="button" id={btnid} className="btn btn-outline-primary mt-3 w-100 d-flex align-items-center justify-content-center">
                                <span className="oi oi-check invisible"/>
                                <p className="px-4 py-1 my-0 text-dark">تغییر عکس</p>
                                <span className="oi oi-file"/>
                            </button>
                            <small>فقط فایل های کمتر از 5 مگابایت بارگذاری میشود</small>
                            <button onClick={(e) => this.deleteFile(e,imgid)} type="button" id="delbtn" className="btn btn-outline-danger mt-3 w-100 d-flex align-items-center justify-content-center">
                                <span className="oi oi-check invisible"/>
                                <p className="px-4 py-1 my-0 text-dark">حذف عکس</p>
                                <span className="oi oi-file"/>
                            </button>
                            <strong>پر کردن فیلدهای ستاره دار اجباری است</strong>

                            <form className="login-form mx-auto">
                                <div className="form-group text-right">
                                    <label className='important-input'>نام و نام خانوادگی</label>
                                    <input
                                        type="name"
                                        className={["form-control", errors['name'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="name"
                                        value={name}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا نام و نام خانوادگی استاد را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['name'] ? 'block':'none'}}>{errors['name']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label className='important-input'>{"نام کاربری (انگلیسی)"}</label>
                                    <input
                                        type="userid"
                                        className={["form-control", errors['userid'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="userid"
                                        value={userid}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^A-Za-z0-9]+$/ig, '')
                                        }}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا یک نام کاربری مشخص کنید . مثال : alireza-sajadi"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['userid'] ? 'block':'none'}}>{errors['userid']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label>{"شماره موبایل"}</label>
                                    <input
                                        type="phone"
                                        className={["form-control", errors['phone'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="phone"
                                        value={phone}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toString().slice(0, 11)
                                            e.target.value = e.target.value.replace(/\D/g, "")
                                        }}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="شماره موبایل استاد را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['phone'] ? 'block':'none'}}>{errors['phone']}</span>
                                </div>
                                <div className="form-group text-right">
                                    <label>بیوگرافی</label>
                                    <textarea
                                        rows="4"
                                        className={["form-control", errors['bio'] ? 'is-invalid':'is-valid'].join(' ')}
                                        name="bio"
                                        value={bio}
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="لطفا بیوگرافی استاد را وارد کنید"/>
                                    <span className="invalid-feedback rtl" style={{display : errors['bio'] ? 'block':'none'}}>{errors['bio']}</span>

                                </div>

                            </form>
                        </div>
                        <div className="modal-footer">
                            <div className="btn-group">
                                <button type="submit" className="btn btn-info" data-dismiss="modal" onClick={this.handleSubmit.bind(this)} >تایید</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">لغو</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalEditMaster;
